import { render, staticRenderFns } from "./ItemDetail.vue?vue&type=template&id=7824b5a4"
import script from "./ItemDetail.vue?vue&type=script&lang=js"
export * from "./ItemDetail.vue?vue&type=script&lang=js"
import style0 from "./ItemDetail.vue?vue&type=style&index=0&id=7824b5a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports